
import endsWith from './endsWith'

const KB = 1024;
const MB = 1024 * KB;
const GB = 1024 * MB;

function format(size, unit) {
    let scalar = parseFloat(size).toFixed(2);
    if (endsWith(scalar, ".00")) {
        scalar = scalar.substr(0, scalar.length - 3);
    }
    return scalar + unit;
}

const humanReadableSize = function(size) {
    if (size >= GB) {
        return format(size / GB, "GB");
    }
    else if (size >= MB) {
        return format(size / MB, "MB");
    }
    else if (size >= KB) {
        return format(size / KB, "KB");
    }
    else {
        return size.toString() + "B";
    }
};

export default humanReadableSize;
